import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  switcher: {
    display: 'flex',
    background: '#f5f5f5',
    borderRadius: 8,
    padding: 4,
  },
  btn: {
    flex: 1,
    padding: '8px 12px',
    fontSize: 13,
    fontWeight: 500,
    background: 'transparent',
    border: 'none',
    borderRadius: 6,
    color: '#666',
    cursor: 'pointer',
    transition: 'all 0.15s ease',
    fontFamily: 'inherit',
    '&:hover': {
      color: '#333',
    },
  },
  active: {
    background: '#ffffff',
    color: '#333',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.08)',
    '&:hover': {
      color: '#333',
    },
  },
}));

const MODES = [
  { key: 'areas', label: 'Areas' },
  { key: 'takeoff', label: 'Takeoff' },
  { key: 'queue', label: 'Queue' },
  { key: 'projects', label: 'Projects' },
];

const ModeSwitcher = ({ activeMode, onModeChange, queueCount = 0 }) => {
  const classes = useStyles();
  return (
    <div className={classes.switcher}>
      {MODES.map((mode) => (
        <button
          key={mode.key}
          type="button"
          className={`${classes.btn} ${activeMode === mode.key ? classes.active : ''}`}
          onClick={() => onModeChange(mode.key)}
        >
          {mode.key === 'queue' && queueCount > 0 ? `${mode.label} (${queueCount})` : mode.label}
        </button>
      ))}
    </div>
  );
};

export default ModeSwitcher;
